module.exports = __webpack_public_path__ + "img/instagram.7742981d.png";